import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  dynamicConfig: any = null;

  constructor(private http: HttpClient) {}

  fetchDynamicConfig(): Promise<void> {
    const url = environment.useEncryption;

    return this.http.get(url).toPromise().then(
      (response) => {
        this.dynamicConfig = response;
        //console.log('Dynamic config fetched:', response);
      },
      (error) => {
        console.error('Error fetching dynamic config:', error);
      }
    );
  }

  getKrakendUrl(): string | null {
    return this.dynamicConfig?.node || null;
  }
}